@ -0,0 +1,216 @@
<template>
  <div class="">
    <Header :title="银行卡管理" right-content="isNo" />
    <div id="content">
      <div class="layout">
          <div class="form-row">
            <label>请输入银行支行名称:</label>
            <br>
            <br>
            <input
              v-model="bankBranch"
              class="input-item"
              :placeholder="支行名称"
              :disabled="hasBankBranch"
              type="text"
            >
            <br>
            <span v-if="hasBankBranch" style="color: red; font-size: 0.28rem;">
              **支行名称无法更改，如有需要请联系客服
            </span>
          </div>
          <div class="form-row">
            <button
              v-if="!hasBankBranch"
              type="button"
              class="control-button"
              @click="handleOnSubmit"
            >
            保存
            </button>
            <p class="warming-tips">新增支行名称，将方便资金快速到账，敬请添加</p>
            <p class="remind-text">保存后无法修改，请仔细操作</p>
          </div>
      </div>
    </div>
    <AlertPop
      :model="showError"
      :use-slot="true"
      button1-txt="知道了"
      @alertOnClose="handleErrorOnClose"
    >
      <span style="color: red">请输入正确的支行名称</span>
      <br>
      <br>
      <!-- <p>微信帐户为6至20位字符</p> -->
    </AlertPop>
    <AlertPop
      :model="showConfirm"
      :use-slot="true"
      button1-txt="确认"
      title="确认支行名称"
      button2-txt="重新输入"
      @alertOnClose="handleConfirmClose"
      @button1Evt="handleSubmit"
      @button2Evt="handleReset"
    >
      <p>支行名称为</p>
      <p style="font-size: 0.4rem; color: rgb(13, 89, 124)">{{ bankBranch }}</p>
    </AlertPop>
    <Chat />
  </div>
</template>
<script>
import Header from '../module/Header.vue'
import AlertPop from '../module/AlertPop.vue'
import api from '@/plugins/api'
import Chat from '../module/Chat.vue'
export default {
  name: 'addBankBranch',
  components: { Header, AlertPop, Chat },
  data() {
    return {
      showConfirm: false,
      showError: false,
      bankBranch: '',
      bankOrder: this.$route.query.bankOrder,
      hasBankBranch: false
    }
  },
  methods: {
    handleOnSubmit() {
      if (
        this.bankBranch === '' 
      ) {
        this.showError = true
        return
      }
      this.showConfirm = true
    },
    handleErrorOnClose() {
      this.showError = false
    },
    handleConfirmClose() {
      this.showConfirm = false
    },
    handleSubmit() {
      const data = {
        bankOrder: this.bankOrder,
        bankBranch: this.bankBranch,
      }
      api
        .updateBankBranch(
          data
        )
        .then((res) => {
          if (res.status === 200) {
            if (res.data.code === 200) {
              this.$toast.success('提交成功，请等待审批完成')
              this.hasBankBranch = true
              return
            }
          }
          this.$toast.warning('更新支行地址失败')
        })
        .catch(() => {
          this.$toast.fail('修改失败，有提案进行中')
        })
    },
    handleReset() {
      this.bankBranch = ''
    }
  }
}
</script>
<style scoped>
.layout {
  display: flex;
  font-size: 0.36rem;
  padding: 0.3rem 0.3rem;
  min-height: 20vh;
  flex-direction: column;
}

.form-row {
  width: 100%;
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}

.input-item {
  font-size: 0.3rem;
  padding: 0;
  width: 5rem;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  width: 4.8rem;
  padding: 0.2rem 0.1rem;
  padding-left: 0.35rem;
  font-size: 0.3rem;
}

.control-button {
  padding: 0.15rem 0.35rem;
  font-size: 0.3rem;
  text-align: center;
  transition: all 0.3s ease-in-out;
  background-color: rgb(91, 155, 213);
  color: white;
  border-radius: 0.15rem;
  outline: none;
  border: 2px solid rgb(13, 89, 124);
}

.warming-tips {
  color: grey;
  font-size: 0.28rem;
  margin-top: 0.3rem;
}

.remind-text {
  color: grey;
  font-size: 0.25rem;
  margin-top: 0.05rem;
}

.alert-bottom button {
  width: 100%;
}
</style>